<div class="banner" id="home">
  <div class="container">
    <div class="bannerSec">
      <div class="row">
        <!-- ======= Banner Left Content ======= -->
        <div class="col-12 col-md-6 leftSec align-self-center">
          <h1 class="banner-title mb-sm-3 " [innerHTML]="'banner.banner_text' | translate"></h1>
          <div class="d-flex wallet_audit_wrap mt-4 align-items-center justify-content-between">
            <a href="https://guide.pepeunchained.com/"
              class="rounded-3 btn btn-primary font-16 d-inline-block dev-doc-btn" target="_blank">{{ 'banner.dev_doc' |
              translate }}</a>
            <div (click)="redirectToExternalURL('https://coinsult.net/projects/pepe-unchained-2/')"
              class="audit-wrapper mb-sm-3 cursor-pointer">
              <p class="text">{{"misc.trust_audit" | translate}}</p>
              <img class="icon" src="/assets/images/svg-icons/audit_1.svg" alt="">
            </div>
          </div>
        </div>

        <!-- ======= Banner right Content ======= -->

        <div class="col-12 col-md-6 rightSec align-self-end">
          <a class="glowBtn btn btn-secondary d-inline-block mwx-286" target="_blank">{{ 'banner.banner_desc' |
            translate }}</a>
        </div>
      </div>
      <app-feature></app-feature>
    </div>

  </div>
</div>